import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Mail } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Anifit is duurder dan mijn huidige voer',
    answer: <div className="space-y-2" data-id="element-57">
          <p className="font-bold" data-id="element-58">Klopt - per blik. Maar reken even mee:</p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-59">
            <li data-id="element-60">Een blik van 810g bevat ~750g vers vlees</li>
            <li data-id="element-61">
              Regulier natvoer met 40% vlees: je hebt bijna 2 blikken nodig voor
              dezelfde hoeveelheid
            </li>
            <li data-id="element-62">Minder dierenartskosten door betere gezondheid</li>
            <li data-id="element-63">Je hond heeft minder nodig omdat alles wordt opgenomen</li>
          </ul>
          <p className="font-medium text-[#4DBFB8] pt-2" data-id="element-64">
            Per gram vlees is Anifit vaak goedkoper dan je denkt.
          </p>
        </div>
  }, {
    question: 'Mijn hond is kieskeurig, eet hij dit wel?',
    answer: <div className="space-y-2" data-id="element-65">
          <p data-id="element-66">
            Honden houden van nature van vers vlees. Als je hond "kieskeurig"
            is, komt dat vaak door:
          </p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-67">
            <li data-id="element-68">
              Gewenning aan kunstmatige smaakversterkers (het
              "McDonald's-effect")
            </li>
            <li data-id="element-69">
              Een verstoorde darmflora waardoor hij slecht reageert op voeding
            </li>
          </ul>
          <p data-id="element-70">
            Anifit heeft geen smaakversterkers nodig - het hoge vleesgehalte en
            natuurlijke vet zijn aantrekkelijk genoeg. Na een korte
            gewenningsperiode gaan de meeste honden er direct op af.
          </p>
          <p className="font-bold pt-2" data-id="element-71">
            Tip: Begin met het Proefpakket om te ontdekken welke smaak favoriet
            is.
          </p>
        </div>
  }, {
    question: 'Ik ben bang voor problemen tijdens de overstap',
    answer: <div className="space-y-2" data-id="element-72">
          <p data-id="element-73">Begrijpelijk. Daarom begeleiden wij je persoonlijk:</p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-74">
            <li data-id="element-75">
              Geleidelijke overgang in 10 dagen (wij leggen precies uit hoe)
            </li>
            <li data-id="element-76">
              Tijdelijke diarree of winderigheid is normaal - teken van
              ontgifting
            </li>
            <li data-id="element-77">Power-Darm versnelt het darmherstel</li>
          </ul>
          <p className="pt-2" data-id="element-78">
            Vragen? Mail ons direct:{' '}
            <a href="mailto:amee@stresslessdogs.nl" className="text-[#4DBFB8] underline" data-id="element-79">
              amee@stresslessdogs.nl
            </a>
          </p>
          <p className="font-medium" data-id="element-80">
            De meeste honden wennen binnen 10 dagen probleemloos.
          </p>
        </div>
  }, {
    question: 'Is het echt zoveel beter dan ander premium natvoer?',
    answer: <div className="space-y-2" data-id="element-81">
          <p data-id="element-82">Check het etiket van je huidige voer en stel deze vragen:</p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-83">
            <li data-id="element-84">
              Staat er exact welk percentage van welk ingrediënt erin zit?
            </li>
            <li data-id="element-85">Is het vlees goedgekeurd voor menselijke consumptie?</li>
            <li data-id="element-86">Staan er conserveringsmiddelen of smaakversterkers in?</li>
            <li data-id="element-87">Wat is de herkomst van het vlees?</li>
          </ul>
          <p className="font-medium text-[#4DBFB8] pt-2" data-id="element-88">
            Anifit scoort op al deze punten. Vergelijk zelf - de verschillen
            zijn vaak groter dan je denkt.
          </p>
        </div>
  }];
  return <section className="py-20 bg-white" data-id="element-89">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-91">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-id="element-92">
            Veelgestelde vragen over Anifit
          </h2>
        </motion.div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-93">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-94">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-gray-50 transition-colors focus:outline-none" data-id="element-95">
                <span className="text-lg font-bold text-gray-900" data-id="element-96">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#4DBFB8] transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-97" />
              </button>

              <AnimatePresence data-id="element-98">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden bg-gray-50" data-id="element-99">
                    <div className="p-6 pt-0 text-gray-600 border-t border-gray-100 mt-4" data-id="element-100">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}